import { styled } from "@mui/material/styles";

const stylesCss = {
  btnRegresar: {
    backgroundColor: "red",
    borderRadius: "13px",
    height: "60px",
    padding: "15px 30px 15px 30px",
    "&:hover": {
      backgroundColor: "#ffcdd2",
      opacity: [0.9, 0.8, 0.7],
      color: "black",
    },
  },
};
const Label = styled("h4")(({ theme }) => ({
  color: "gray",
  paddingBottom: "25px",
}));

export default stylesCss;
export { Label };
